import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import authReducer from "./auth";
import barcodeReducer from "./barcode";
import displayReducer from './display';
import listReducer from './list';
import messagesReducer from "./messages";
import singleReducer from "./single";
// import initialState from "../initialState";

const reducer = combineReducers({
  auth: authReducer,
  barcode: barcodeReducer,
  display: displayReducer,
  form: formReducer,
  list: listReducer,
  messages: messagesReducer,
  single: singleReducer,
});

export default reducer;